import React, { useState } from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const amounts = ['₦2,000', '₦5,000', '₦10,000', '₦25,000', '₦50,000'];
export function SupportCampaign() {
  const [selected, setSelected] = useState<string | null>('₦5,000');
  const [custom, setCustom] = useState('');
  return <section aria-labelledby="support-heading" className="bg-ink py-16 sm:py-20 lg:py-24" data-id="element-350" data-mp="xxb8pw5aycp8">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-351" data-mp="12ul9g7y56asd">
        <div className="grid gap-10 rounded-media border border-white/10 bg-ink-700 p-7 sm:p-10 lg:grid-cols-12 lg:items-center lg:gap-14 lg:p-14" data-id="element-352" data-mp="17tei9n2hhdm7">
          <div className="lg:col-span-5" data-id="element-353" data-mp="1cr6f8vhzjpx9">
            <p className="text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-354" data-mp="1gv5p4v8rfqhn">
              Support the campaign
            </p>
            <h2 id="support-heading" className="mt-4 font-display text-[30px] leading-[1.1] tracking-[-0.02em] text-white sm:text-[38px]" data-id="element-355" data-mp="3emqh6veax62j">
              This campaign is funded by Nigerians, and answerable to them.
            </h2>
            <p className="mt-4 text-[16px] leading-relaxed text-white/70" data-id="element-356" data-mp="2p448ytdqrcgs">
              Every contribution is receipted, reported and published in line with the Electoral
              Act. No contribution buys access, appointments or contracts.
            </p>
            <p className="mt-6 flex items-start gap-2.5 text-[13px] text-white/55" data-id="element-357" data-mp="3cu70n8dqugev">
              <ShieldCheckIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" data-id="element-358" data-mp="37vdtdxp1vln5" />
              Open only to eligible Nigerian citizens. Read the{' '}
              <a href="#" className="underline decoration-white/30 underline-offset-2 hover:text-white" data-id="element-359" data-mp="32ug1gte8nd8g">
                contribution rules
              </a>
              .
            </p>
          </div>

          <div className="rounded-card border border-white/10 bg-white/[0.04] p-6 sm:p-8 lg:col-span-7" data-id="element-360" data-mp="1rif9z6pzpap0">
            <fieldset data-id="element-361" data-mp="1mk5cuqkpg00r">
              <legend className="text-[14px] font-semibold text-white" data-id="element-362" data-mp="eilqm4zz9yv6">
                Choose an amount
              </legend>
              <div className="mt-4 flex flex-wrap gap-2.5" data-id="element-363" data-mp="ikgunh9amqcn">
                {amounts.map(amount => {
                const isActive = selected === amount;
                return <button key={amount} type="button" aria-pressed={isActive} onClick={() => {
                  setSelected(amount);
                  setCustom('');
                }} className={`rounded-lg border px-4 py-2.5 text-[15px] font-semibold transition-colors duration-150 ease-emphasis ${isActive ? 'border-gold-400 bg-gold-400 text-ink' : 'border-white/25 text-white hover:border-white/50'}`} data-id="element-364" data-mp="9izddvk5gimd">
                      {amount}
                    </button>;
              })}
              </div>
            </fieldset>

            <div className="mt-5" data-id="element-365" data-mp="2pdcc09yc3933">
              <label htmlFor="custom-amount" className="block text-[14px] font-medium text-white/80" data-id="element-366" data-mp="2pef24fnu17hy">
                Or enter another amount
              </label>
              <div className="mt-2 flex items-center rounded-lg border border-white/25 bg-ink/40 focus-within:border-gold-400" data-id="element-367" data-mp="2ycze6xyw0ix7">
                <span className="pl-4 text-[15px] text-white/60" data-id="element-368" data-mp="3cbz2u5megxtd">₦</span>
                <input id="custom-amount" type="text" inputMode="numeric" value={custom} placeholder="0" onChange={event => {
                setCustom(event.target.value.replace(/[^0-9]/g, ''));
                setSelected(null);
              }} className="w-full bg-transparent px-2 py-3 text-[15px] text-white placeholder:text-white/35 focus:outline-none" data-id="element-369" data-mp="38c833cewb7cp" />
              </div>
            </div>

            <Button size="lg" className="mt-6 w-full" data-id="element-370" data-mp="1odg8pdx7hxsd">
              Continue to support
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-371" data-mp="1tcsurwg970tw" />
            </Button>
            <p className="mt-3 text-center text-[12px] text-white/45" data-id="element-372" data-mp="1y5u8w28mywcf">
              You will confirm your details and eligibility before any payment is taken.
            </p>
          </div>
        </div>
      </div>
    </section>;
}